<template>
  <div>
    <landingBanner :bannerList="Banners" :bannerName="SomeValue" />

    <section class="home-slider py-1 d-none">
      <Slick ref="slick1" :options="homeSlider">
        <!-- DESKTOP SLIDER -->
        <div
          v-if="singleBanner.movie"
          v-for="(singleBanner, bannerKey) in Banners"
          :key="bannerKey"
        >
          <div
            v-if="bannerKey != Banners.length - 1"
            class="slider-container d-flex"
          >
            <div class="col-6 col-sm-5 col-md-5 col-lg-3 col-xl-3 px-0">
              <img
                :src="singleBanner.movie_card_img"
                class="img-fluid rounded-left"
                alt="Banner Images"
              />
            </div>
            <div
              class="col-6 col-sm-7 col-md-7 col-lg-9 col-xl-9 d-flex flex-column justify-content-between py-3"
            >
              <div>
                <div class="mb-3 slider-title">{{ singleBanner.title }}</div>

                <div class="movie-information mb-3">
                  <span class="font-weight-bold">{{ singleBanner.rated }}</span>
                  <span class="mx-1">|</span>
                  <span>{{ singleBanner.genre }}</span>
                  <span class="mx-1">|</span>
                  <span>{{ singleBanner.lang }}</span>
                  <span class="mx-1">|</span>
                  <span
                    :class="project == 'wanasatime' ? 'format_my' : 'format'"
                    >2D</span
                  >
                  <span
                    :class="project == 'wanasatime' ? 'format_my' : 'format'"
                    >3D</span
                  >
                </div>

                <div class="mb-3 d-md-block d-none">
                  <p class="font-weight-bold">{{ singleBanner.plot }}.</p>
                </div>

                <div class="row">
                  <div class="col-md-4 col-xl-3">
                    <div
                      class="movie-release mr-2 d-flex align-items-center mb-1"
                    >
                      <img
                        src="@/assets/img/icon-calender.png"
                        class="mr-1"
                        height="15px"
                        width="15px"
                      />
                      {{ singleBanner.release }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4 col-xl-2">
                      <div
                        class="movie-release mr-2 d-flex align-items-center mb-1"
                      >
                        <img
                          src="@/assets/img/icon-calender.png"
                          class="mr-1"
                          height="15px"
                          width="15px"
                        />
                        {{ singleBanner.release }}
                      </div>
                    </div>

                    <div class="col">
                      <div class="movie-duration d-flex align-items-center">
                        <img
                          src="@/assets/img/icon-clock.png"
                          class="mr-1"
                          height="15px"
                          width="15px"
                        />
                        {{ singleBanner.runtime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <router-link
                    :to="{
                      name: 'movie',
                      params: { movieID: singleBanner.id, cinemaID: '0' }
                    }"
                  >
                    <button class="btn-booknow">
                      <img
                        src="@/assets/img/icon-booknow.png"
                        height="auto"
                        width="18px"
                        alt="Ticket-icon"
                      />
                      {{ $t("BOOK_NOW") }}
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div v-if="bannerKey == Banners.length - 1" class="slider-container">
            <img src="@/assets/img/aquaman_1475_555.jpg" class="img-fluid" />
          </div>
        </div>
      </Slick>
    </section>

    <div id="quickbook"></div>

    <!-- QUICKBOOK COMPONENT -->
    <QuickBook v-if="!underMaintainance" class="quick-book-sticky  d-sm-block mt-md-5 py-1" />
    <!-- QUICKBOOK MODAL BUTTON FOM MOBILE -->
    <button
      v-b-modal.quickBook-modal
      class="btn-quickbook d-sm-none my-4 d-none"
    >
      Quick Book
    </button>

    <b-modal
      centered
      hide-footer
      hide-header
      id="quickBook-modal"
      title="BootstrapVue"
      class="p-0"
    >
      <QuickBook />
    </b-modal>

    <!--Advertisement Image-->

    <!-- <div class="advertisement_img mt-4 col-md-12 col-lg-12 col-sm-12">
      <img src="@/assets/img/banner_adv.svg" />
    </div> -->

    <section class="wrapper pt-0 home-movie-event-view">
      <div class="col-12 col-lg-12 col-xl-11 mx-auto px-0">
        <div
          class="section-menu section-menu-sticky mb-2 mt-4"
          :class="isRTL ? 'rtl' : ''"
        >
          <div class="section-title d-none d-md-block">
            {{ $t("MOVIES_FOR_YOU") }}
          </div>
          <ul class="status-filter">
            <!--<li
              class
              v-bind:class="{ active: visibleShows.title == 'Now Showing' || !visibleShows.hasOwnProperty('title') }"
              v-on:click="visibleShows = {
                show: [...Shows[0].show,...Shows[1].show]
              }"
            >Now Showing</li>-->
            <li
              class
              v-bind:class="{
                active:
                  visibleShows.title == 'Now Showing' ||
                  !visibleShows.hasOwnProperty('title')
              }"
              v-on:click="filterShow('nowShowing')"
            >
              {{ $t("NOW_SHOWING") }}
            </li>
            <!-- <li
              v-if="project != 'wanasatime'"
              class
              v-bind:class="{ active: visibleShows.title == 'Alternate' }"
              v-on:click="filterShow('Alternate')"
            >
              Alternate
            </li> -->
            <li
              class
              v-bind:class="{ active: visibleShows.title == 'Coming Soon' }"
              v-on:click="filterShow('Coming Soon')"
            >
              {{ $t("COMING_SOON") }}
            </li>
          </ul>
        </div>

        <div class="row">
          <div
            class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 d-none d-md-block h-100"
            :class="isIE == true ? '' : 'sticky-custom'"
            v-if="false"
          >
            <div
              v-if="filtersChips.length > 0"
              v-on:click="onClearAllFilters()"
              class="d-none text-right mb-1 text-pink cursor-pointer"
            >
              Clear All
            </div>
            <!-- <section class="filter-modal"> -->
            <div class>
              <div
                class="accordian-container"
                v-for="(filter, filterKey) in filters"
                :key="filterKey"
                v-if="false"
              >
                <button
                  :class="
                    selectedFilter &&
                    selectedFilter[filter.filter_key] &&
                    selectedFilter[filter.filter_key].length > 0
                      ? 'active'
                      : ''
                  "
                  class="btn-accordian no-focus"
                  @click="onToggle(filter.collapseId)"
                >
                  <img :src="filter.icon" height="15px" width="15px" />
                  {{ filter.filter_name }}
                </button>
                <b-collapse
                  class="accordian-container"
                  :id="filter.collapseId"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <label
                    :for="filter.filter_key + filterListKey"
                    class="btn-accordian-child d-flex align-items-center"
                    v-for="(filterList, filterListKey) in filter.all_filter"
                    :key="filterListKey"
                  >
                    <input
                      :id="filter.filter_key + filterListKey"
                      v-on:click="
                        onClickFilter(
                          filter.filter_key,
                          filterList.value,
                          filterListKey,
                          filterList.title
                        )
                      "
                      type="checkbox"
                      :checked="
                        selectedFilter[filter.filter_key] &&
                        filterList.value ==
                          selectedFilter[filter.filter_key][filterListKey]
                          ? true
                          : false
                      "
                    />
                    <label
                      class="mb-0"
                      :for="filter.filter_key + filterListKey"
                      >{{ filterList.title }}</label
                    >
                  </label>

                  <!-- <div
                    class="btn-accordian-child d-flex align-items-center"
                    :class="(selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][filterListKey]) ? 'active':''"
                    v-for="(filterList ,filterListKey) in filter.all_filter"
                    v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                    :key="filterListKey"
                  >
                    <label class="mb-0 chkbox active" :for="filter.filter_key+filterListKey">
                      <input :id="filter.filter_key+filterListKey" class="d-none" type="checkbox" />
                    </label>
                    {{filterList.title}}
                  </div>-->

                  <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
                  </ul>-->
                </b-collapse>
              </div>
            </div>
            <!-- <Advertise /> -->
            <!-- </section> -->
          </div>

          <div
            class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 d-none h-100 sticky-custom"
          >
            <!-- ALL LOCATIONS FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.locations class="btn-accordian">
                <img
                  src="@/assets/img/location-pin.png"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.locations.selected.Title }}
              </button>
              <b-collapse class="btn-accordian-content" id="locations">
                <button
                  v-b-toggle.locations
                  v-for="(location, locationListIndex) in dropDowns.locations
                    .list"
                  :key="locationListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(location, 'location')"
                >
                  {{ location.Title }}
                </button>
              </b-collapse>
            </div>

            <!-- ALL LANGUAGES FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.languages class="btn-accordian">
                <img
                  src="@/assets/img/svg/icon-world.svg"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.languages.selected.LanguageName }}
              </button>
              <b-collapse class="btn-accordian-content" id="languages">
                <button
                  v-b-toggle.languages
                  v-for="(lang, languageListIndex) in dropDowns.languages.list"
                  :key="languageListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(lang, 'language')"
                >
                  {{ lang.LanguageName }}
                </button>
              </b-collapse>
            </div>

            <!-- ALL GENERE FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.genre class="btn-accordian">
                <img
                  src="@/assets/img/icon-genre.png"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.genre.selected.Genre }}
              </button>
              <b-collapse class="btn-accordian-content" id="genre">
                <button
                  v-b-toggle.genre
                  v-for="(genre, genreListIndex) in dropDowns.genre.list"
                  :key="genreListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(genre, 'genre')"
                >
                  {{ genre.Genre }}
                </button>
              </b-collapse>
            </div>

            <!-- EXPERIENCE FILTER -->
            <div class="accordian-container">
              <button v-b-toggle.experience class="btn-accordian">
                <img
                  src="@/assets/img/icon-format.png"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.experience.selected.Format }}
              </button>
              <b-collapse class="btn-accordian-content" id="experience">
                <button
                  v-b-toggle.experience
                  v-for="(experience, ExperienceListIndex) in dropDowns
                    .experience.list"
                  :key="ExperienceListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(experience, 'experience')"
                >
                  {{ experience.Format }}
                </button>
                <!-- <button v-b-toggle.genre class="btn-accordian-child">2D</button>
                <button v-b-toggle.genre class="btn-accordian-child">3D</button>
                <button v-b-toggle.genre class="btn-accordian-child">4D</button>
                <button v-b-toggle.genre class="btn-accordian-child">4DX</button>-->
              </b-collapse>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div>
              <ul class="list-inline">
                <li
                  v-for="(filter, filterKey) in filtersChips"
                  :key="filterKey"
                  class="list-inline-item"
                >
                  <div class="badge badge-pill bg-pink text-white">
                    {{ filter.title }}
                    <button
                      v-on:click="
                        onRemoveFilterChips(
                          filter.filter_key,
                          filter.value,
                          filterKey
                        )
                      "
                      class="btn-badge-close"
                    >
                      x
                    </button>
                  </div>
                </li>
                <li
                  v-if="filtersChips.length > 0"
                  class="list-inline-item d-none"
                >
                  <div class="badge badge-pill bg-pink text-white">
                    Clear All
                    <button
                      v-on:click="onClearAllFilters()"
                      class="btn-badge-close"
                    >
                      x
                    </button>
                  </div>
                </li>
              </ul>
            </div>
            <div
              v-if="visibleShows.show && visibleShows.show.length > 0"
              class="row row-cols-4"
              :class="isRTL ? 'rtl' : 'ltr'"
            >
              <div
                v-for="(movie, index222) in visibleShows.show"
                :key="index222"
                class="col-6 col-md-3 px-0 col"
              >
                <router-link @click.native="goToRoute(movie)" to>
                  <!-- :to="movie.url" -->
                  <div class="movie-card">
                    <span
                      v-if="movie.flagname.length > 0"
                      class="advance-booking"
                      >{{ movie.flagname }}</span
                    >
                    <img
                      v-lazy="movie.movie_card_img"
                      class="movie-poster"
                      :alt="movie.title"
                    />
                    <div class="middle">
                      <div class="text">{{ $t("BOOK_NOW") }}</div>
                    </div>
                    <div class="movie-content">
                      <div
                        :class="[
                          'movie-name',
                          isRTL ? 'rtl text-right' : 'ltr'
                        ]"
                      >
                        {{ movie.title }}
                      </div>
                      <div class="d-flex flex-wrap">
                        <div class="fs-14 text-light">
                          <!--span>{{movie.rated}}</span>
                          <span>|</span>
                          <span>{{movie.genre}}</span>
                          <span>|</span>
                          <span>{{movie.lang}}</span>
                          <span>|</span>
                          <span class="format"  :style="project == 'wanasa' ? 'color:white;' : ''">{{ movie.format }}</span--->
                          <div class="d-flex movie_data">
                            <span>{{ movie.rated }}</span>
                            <span>{{ movie.language }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="visibleShows.title == 'Coming Soon'"
                        class="d-done d-flex flex-wrap mb-3 mb-md-0"
                      >
                        <div
                          class="movie-release mr-2 d-flex align-items-center"
                        >
                          <!-- <img
                            src="@/assets/img/icon-calender.png"
                            class="mr-1"
                            height="15px"
                            width="15px"
                          />-->
                          <span class="fs-14 text-dark">
                            Release Date:&nbsp;
                            {{ movie.release }}
                          </span>
                        </div>
                      </div>
                      <div
                        v-if="visibleShows.title == 'Coming Soon'"
                        class="d-flex align-items-center"
                      >
                        <div
                          class="favourite"
                          v-on:click="
                            addtoFav(
                              $event,
                              movie,
                              movie.id,
                              visibleShows['cat_id']
                            )
                          "
                          :class="movie.favourite ? 'check' : ''"
                        ></div>
                        <label class="mb-0" for="fav">Interested</label>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>

              <!-- <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4">
                <router-link to="#">
                  <div class="movie-card">
                    <img src="@/assets/img/alita325.jpg" class="w-100" alt>
                    <div class="movie-content">
                      <div class="movie-name">Alita</div>
                      <div class="d-flex flex-wrap text-dark fpx">
                        <span>English</span>
                        <span class="mx-1">|</span>
                        <span>Genere</span>
                        <span class="mx-1">|</span>
                        <div>
                          <span class="format">2D</span>
                          <span class="format">3D</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>-->
            </div>
            <div
              v-else-if="
                visibleShows &&
                  visibleShows.show &&
                  visibleShows.show.length == 0 &&
                  !data_loading
              "
              class="text-dark"
            >
              {{ $t("NO_MOVIES_FOUND_FOR_THE_SELECTED_CRITERIA") }}
            </div>

            <div>
              <!-- <PromoSlider/> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FIXED BOTTOM BUTTON -->
    <section class="fixed-filter d-lg-none d-md-none d-sm-none" v-if="false">
      <!-- <button v-b-modal.quickBook-modal class="btn-filter-quickbook">Quick Book</button> -->
      <button
        style="width:100%"
        v-on:click="filterModal = !filterModal"
        class="btn-filter"
      >
        Filter
      </button>
    </section>

    <!-- FILTER MODAL START-->
    <section v-if="filterModal" class="filter-modal">
      <div class="filter-modalContent">
        <nav>
          <img
            src="@/assets/img/svg/arrow-left.svg"
            height="20px"
            width="20px"
            alt="Back"
            v-on:click="filterModal = !filterModal"
          />
          <h6>Filter</h6>
          <a class="btn-reset">RESET</a>
        </nav>

        <div class>
          <div
            class="accordian-container"
            v-for="(filter, filterKey) in filters"
            :key="filterKey"
          >
            <button
              :class="
                selectedFilter &&
                selectedFilter[filter.filter_key] &&
                selectedFilter[filter.filter_key].length > 0
                  ? 'active'
                  : ''
              "
              class="btn-accordian no-focus"
              @click="onToggle(filter.collapseId)"
            >
              <img :src="filter.icon" height="15px" width="15px" />
              {{ filter.filter_name }}
            </button>
            <b-collapse
              class="accordian-container"
              :id="filter.collapseId"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div
                class="btn-accordian-child d-flex align-items-center"
                v-for="(filterList, filterListKey) in filter.all_filter"
                :key="filterListKey"
              >
                <input
                  :id="filter.filter_key + filterListKey"
                  v-on:click="
                    onClickFilter(
                      filter.filter_key,
                      filterList.value,
                      filterListKey,
                      filterList.title
                    )
                  "
                  type="checkbox"
                  :checked="
                    selectedFilter[filter.filter_key] &&
                    filterList.value ==
                      selectedFilter[filter.filter_key][filterListKey]
                      ? true
                      : false
                  "
                />
                <label class="mb-0" :for="filter.filter_key + filterListKey">{{
                  filterList.title
                }}</label>
              </div>

              <!-- <div
                    class="btn-accordian-child d-flex align-items-center"
                    :class="(selectedFilter[filter.filter_key] && filterList.value == selectedFilter[filter.filter_key][filterListKey]) ? 'active':''"
                    v-for="(filterList ,filterListKey) in filter.all_filter"
                    v-on:click="onClickFilter(filter.filter_key,filterList.value,filterListKey,filterList.title)"
                    :key="filterListKey"
                  >
                    <label class="mb-0 chkbox active" :for="filter.filter_key+filterListKey">
                      <input :id="filter.filter_key+filterListKey" class="d-none" type="checkbox" />
                    </label>
                    {{filterList.title}}
              </div>-->

              <!-- <ul class="filter-list accordian-container">
                    <li
                      class="btn-accordian-child"
                      v-for="(filterList ,filterListKey) in filter.all_filter"
                      :key="filterListKey"
                    >
                      <label for="date">{{filterList.title}}</label>
                      <input id="date" type="checkbox" />
                    </li>
              </ul>-->
            </b-collapse>
          </div>
        </div>

        <div class="btn-container">
          <button
            v-on:click="filterModal = !filterModal"
            class="btn-applyFilter no-focus"
          >
            APPLY FILTER
          </button>
        </div>
      </div>
    </section>
    <!-- FILTER MODAL END -->

    <!--Slider-->
    <BannerSecond :bannerList="Banners" :bannerName="SomeValue" v-if="false" />

    <!--Slider End-->

    <!--Events For you-->

    <!-- <section class="wrapper pt-0">
    <div class="col-12 col-lg-12 col-xl-11 mx-auto px-0">
        <div class="section-menu section-menu-sticky mb-2 mt-4" >
          <div class="section-title d-none d-md-block">{{$t("EVENTS_FOR_YOU")}}</div>
          </div>

      <div class="row" :class="isRTL ? 'rtl' : 'ltr'">
           <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-2 mb-4">
            
                
                  <div class="movie-card" @click="eventDetail()">
                   
                    <img src="@/assets/img/alita-poster.jpg" class="movie-poster"  />
                      <div class="middle">
                      <div class="text">{{$t("BOOK_NOW")}}</div>
                    </div>
                    <div class="event-content">
                      <div class="movie-name">Alita: Battle Angel</div>
                      <div class="d-flex flex-wrap">
                        <div class="fs-14 text-light">
                          <div>
                            <span class="genre_events">Action</span>
                          </div>
                      <div class="d-flex event_data pt-2">
                        <img src="@/assets/img/icons/calendar-white.svg"/>
                        <span>Fri 12,Mar</span>
                
                        </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
              
          </div>
          
          </div>
          </div>
      
    </section> -->

    <!-- Show Promotion Popup -->
    <b-modal
      ref="offerpopup"
      id="offerpopup"
      hide-header-close
      hide-header
      hide-footer
    >
      <div class="modal-title d-none">Hey!</div>
      <div class="text-center text-white mt-3 mt-md-0">
        <img :src="popupImg" class="w-100" />
      </div>
      <div class="text-center my-3" v-if="isUserLoggedIn">
        <button
          v-on:click="onCloseCurrentModal('offerpopup')"
          class="ticketak-btn"
        >
          {{ $t("BOOK_NOW") }}
        </button>
        <br />
        <router-link style="color:#fff; font-size:12px;" to="/promotions"
          >Terms & Conditions</router-link
        >
      </div>
      <div class="text-center my-3" v-else>
        <p class="rounded d-table mx-auto refer_code border-0">
          <a
            v-b-modal.signIn
            @contextmenu="handler($event)"
            class="ticketak-btn"
            >Login</a
          >
          &nbsp;
          <u style="color:#fff;">OR</u>&nbsp;
          <a
            v-b-modal.signUp
            @contextmenu="handler($event)"
            class="ticketak-btn"
            >Register</a
          >
        </p>
      </div>
    </b-modal>

    <!-- MODAL -->

    <div class="section-space"></div>
  </div>
</template>

<script>
import Slick from "vue-slick";
//import carousel from "vue-owl-carousel";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import {
  PROJECT,
  METAWEBSITE,
  METAORGANIZATION,
  metaInfo
} from "@/helper/constant.js";
import QuickBook from "@/components/partials/QuickBook.vue";
import BannerSecond from "@/components/partials/BannerSecond.vue";
import landingBanner from "@/components/partials/mainBanner";

import $ from "jquery";
import { EventBus } from "@/main";
import {
  LanguageService,
  CountryService,
  TokenService
} from "@/services/storage.service";
import { ReferralService } from "@/services/storage.service";
import { uniqBy } from "lodash";
import Advertise from "@/components/partials/advertise.vue";
import { mapGetters } from "vuex";
export default {
  name: "homepage",

  metaInfo: metaInfo,
  components: {
    Slick,
    QuickBook,
    landingBanner,
    Advertise,
    BannerSecond

    // PromoSlider
  },
  data() {
    return {
      underMaintainance: false,
      popupImg: "",
      isUserLoggedIn: false,
      showOfferPopup: false,
      jsonWebsite: [],
      jsonOrganization: [],
      isIE: false,
      project: PROJECT,
      metaWebsite: METAWEBSITE,
      metaOrganization: METAORGANIZATION,
      filterModal: false,
      SomeValue: "SomeValue",
      homeSlider: {
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "3.5%",
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: true,
              centerMode: false,
              slidesToShow: 1,
              autoplaySpeed: 7000,
              autoplay: true,
              slidesToScroll: 1
            }
          }
        ]
      },
      Shows: [],
      AllShows: {
        show: []
      },
      Banners: [],
      visibleShows: {
        title: "Now Showing"
      },
      filters: [],
      selectedFilter: {},
      dropDowns: {
        locations: {
          selected: {
            Title: "All Locations"
          },
          list: []
        },
        languages: {
          selected: {
            LanguageName: "All Languages"
          },
          list: []
        },
        cinemaChain: {
          selected: {
            OrganizationName: "All Cinemas"
          },
          list: []
        },
        genre: {
          selected: {
            Genre: "All Genre"
          },
          list: []
        },
        experience: {
          selected: {
            Format: "All Experience"
          },
          list: []
        }
      },
      filtersChips: [],
      quickBook: {
        movies: [],
        movieSelected: "",
        cinemaSelected: "",
        dateSelected: "",
        timeSelected: "",
        cinemas: [],
        date: [],
        time: [],
        allData: [],
        filteredData: []
      },
      referralCode: "",
      message: "",
      userDetails: {},
      utm: {
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
        utm_content: ""
      }
    };
  },
  computed: {
    ...mapGetters(["isRTL"])
  },
  beforeMount() {
    this.fetchUserDetails();
    this.getAllCountry();
    this.getMeta();
    this.secureStore.remove("SF");
    // this.getNowShowingData();
    // this.getAllFilters();
    // this.getQuickBookDetails();
    // this.getLanguages();
  },

  mounted() {
    metaInfo.title =
      "Online Ticket Booking for Movies and Events near You in Bahrain - Wanasatime";
    metaInfo.meta[2].content =
      "Online ticket booking for all the movies and events showing near you in Bahrain | Wanasatime, Cinema Bahrain";
    metaInfo.meta[3].content =
      "online ticket booking, cinema bahrain, Cinema online booking, cinema ticket booking, Movie Trailers, Reviews";
    this.isIE = this.$browserDetect.isIE;
    this.SomeValue = "OtherValue";
    //if url is referal, check value
    if (this.$route.path.includes("referral")) {
      this.referralCode = this.$route.params.code;
      ReferralService.saveReferral(this.referralCode);
      EventBus.$emit("openSignUpModal");
    }

    EventBus.$on("UserLoggedIn", data => {
      console.log("data>>>>>>>>>>>>>>>>>>>>> :", data);
      this.userDetails = data;
      this.isUserLoggedIn = true;
    });

    //UTM Details Start Here
    this.utm.utm_source = this.$route.query.hasOwnProperty("utm_source")
      ? this.$route.query.utm_source
      : "";
    if (this.utm.utm_source != "") {
      TokenService.saveUTM("utm_source", this.utm.utm_source);
    }
    this.utm.utm_medium = this.$route.query.hasOwnProperty("utm_medium")
      ? this.$route.query.utm_medium
      : "";
    if (this.utm.utm_medium != "") {
      TokenService.saveUTM("utm_medium", this.utm.utm_medium);
    }
    this.utm.utm_campaign = this.$route.query.hasOwnProperty("utm_campaign")
      ? this.$route.query.utm_campaign
      : "";
    if (this.utm.utm_campaign != "") {
      TokenService.saveUTM("utm_campaign", this.utm.utm_campaign);
    }
    this.utm.utm_content = this.$route.query.hasOwnProperty("utm_content")
      ? this.$route.query.utm_content
      : "";
    if (this.utm.utm_content != "") {
      TokenService.saveUTM("utm_content", this.utm.utm_content);
    }

    TokenService.saveUTM("utm", JSON.stringify(this.utm));
    //UTM Details End Here

    // this.getAllFilters();
    // this.getNowShowingData();
    // EventBus.$emit("onClickLogo");

    EventBus.$on("onClickLogo", () => {
      // this.selectedFilter = {};
      this.getNowShowingData();
      // this.getAllFilters();
    });
  },
  afterMount() {
    // this.getQuickBookDetails();
    // this.getLanguages();
  },

  methods: {
    eventDetail() {
      this.$router.push("/eventDetails");
    },
    onShowCurrentModal: function(ref) {
      console.log("ref :", ref);
      this.$refs[ref].show();
    },
    onCloseCurrentModal: function(ref) {
      this.$refs[ref].hide();
    },
    goToRoute: function(movie) {
      this.secureStore.set("SF", this.selectedFilter);
      let selectedFilter = this.selectedFilter;
      let visibleShows = this.visibleShows;
      this.$router.push({
        name: "movie",
        params: {
          movieID: movie.id,
          cinemaID: "0",
          props: { selectedFilter, cat_id: visibleShows["cat_id"] }
        }
      });
    },
    getMeta: function() {
      makeRequest("/HomeMeta", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (!error && res.data.Status) {
            this.jsonWebsite = res.data.Data.website;
            this.jsonOrganization = res.data.Data.Organization;
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getAllCountry: function(country) {
      let countryData = CountryService.getCountry();
      makeRequest("/GetCountryList", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          this.countries = res.data.List;
          if (!error && res.data.Status) {
            this.countries = res.data.List;
            /*
            if (countryData == null && this.countries.length > 1) {
              if (this.project == "ticketak") {
                this.$root.$emit("bv::show::modal", "countryModalRef");
              } else if (this.project == "wanasa") {
                if (res.data["Popup"]) {
                  this.$root.$emit("bv::show::modal", "countryModalRef");
                } else {
                  this.$root.$emit("bv::hide::modal", "countryModalRef");
                  CountryService.saveCountry(res.data.Default);
                  this.countrySelected = res.data.Default.CountryName;
                  EventBus.$emit("selectedCountry", this.countrySelected);
                  this.getNowShowingData();
                  this.getAllFilters();
                  EventBus.$emit("ResetQuickBook");
                }
              }
            } else if (this.countries.length == 1) {
              this.countries.map(x => {
                if (x.CountryID == "230" || x.CountryID == "112") {
                  countryData = x;
                  CountryService.saveCountry(countryData);
                  this.countrySelected = x.CountryName;
                  EventBus.$emit("selectedCountry", this.countrySelected);
                  this.getNowShowingData();
                  this.getAllFilters();
                  EventBus.$emit("ResetQuickBook");
                }
              });
            } else {
              this.getNowShowingData();
              this.getAllFilters();
            }
            */
            if (countryData == null && res.data.List.length > 1) {
              let defaultCountry = res.data.Default;
              if (
                defaultCountry.CountryID == null ||
                res.data.List.filter(
                  c => c.CountryID === defaultCountry.CountryID
                ).length === 0
              ) {
                // this.$root.$emit("bv::show::modal", "countryModalRef");
              }
            } else if (res.data.List.length === 1) {
              countryData = res.data.List[0];
              CountryService.saveCountry(countryData);
              this.countrySelected = countryData.CountryName;
              EventBus.$emit("selectedCountry", this.countrySelected);
              EventBus.$emit("ResetQuickBook");
            }
            this.getNowShowingData();
            // this.getAllFilters();
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    onfbshare() {
      window.open(
        "fb-messenger://share?link=" +
          encodeURIComponent(this.message) +
          "&app_id=" +
          encodeURIComponent("304861010210706")
      );
    },
    onCopy: function(e) {
      this.$toasted.show("Link copied to clipboard");
      setTimeout(() => {
        this.$toasted.clear();
      }, 3000);
    },
    fetchUserDetails: function() {
      let token = TokenService.getToken();
      if (token) {
        makeRequest(`/GetProfile`, "POST", token, null)
          .then(result => {
            this.userDetails = result.res.data;
            this.message =
              window.location.origin +
              "/referral/" +
              this.userDetails.ReferalCode;
          })
          .catch(error => {
            console.log(" Error", error);
          });
      }
    },
    onToggle: function(index) {
      this.$root.$emit("bv::toggle::collapse", index);
    },

    onClearAllFilters: function() {
      this.filtersChips = [];
      this.selectedFilter = {};
      // this.getAllFilters();

      this.getNowShowingData();
    },
    onClickFilter: function(filter_key, value, index, title) {
      let __index = this.filtersChips.findIndex(x => x.title === title);

      if (__index > -1) {
        this.filtersChips.splice(__index, 1);
      } else {
        this.filtersChips.push({
          title: title,
          filter_key: filter_key,
          value: value
        });
      }
      let obj = {};
      obj[filter_key] = [];

      this.selectedFilter = {
        ...obj,
        ...this.selectedFilter
      };
      let _index = this.selectedFilter[filter_key].indexOf(value);
      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      } else {
        this.selectedFilter[filter_key].push(value);
      }
      $("html, body").animate(
        {
          scrollTop: $("#quickbook").offset().top
        },
        1000
      );
      this.getNowShowingData();
    },
    onRemoveFilterChips(filter_key, value, index) {
      this.filtersChips.splice(index, 1);
      let _index = this.selectedFilter[filter_key].indexOf(value);

      if (_index > -1) {
        this.selectedFilter[filter_key].splice(_index, 1);
      }
      this.getNowShowingData();
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(" ");
    },
    filterData: function(data, filter) {
      $("html, body").animate(
        {
          scrollTop: $("#quickbook").offset().top
        },
        1000
      );
      if (filter == "language") {
        this.dropDowns.languages.selected = data;
      }
      if (filter == "genre") {
        this.dropDowns.genre.selected = data;
      }
      if (filter == "experience") {
        this.dropDowns.experience.selected = data;
      }
      if (filter == "location") {
        this.dropDowns.locations.selected = data;
      }

      this.getNowShowingData();
    },
    getAllFilters: function() {
      let payload = {
        FilterType: "Home"
      };
      makeRequest("/GetAllFilter", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            this.filters = [];
            res.data.Filters.map((x, index) => {
              this.filters.push({
                ...x,
                collapseId: "collapse-" + (index + 1)
              });
            });
            // this.dropDowns.locations.list = res.data.List.Locations;
            // this.dropDowns.locations.list.push({
            //   Title: "All Locations"
            // });

            // this.dropDowns.languages.list = res.data.List.Language;
            // this.dropDowns.languages.list.push({
            //   LanguageName: "All Languages"
            // });

            // this.dropDowns.genre.list = res.data.List.Genre;
            // this.dropDowns.genre.list.push({
            //   Genre: "All Genre"
            // });
            // this.dropDowns.experience.list = res.data.List.Experince;
            // this.dropDowns.experience.list.push({
            //   Format: "All Experience"
            // });
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    addtoFav(event, movieDetails, movieID, cat_id) {
      event.preventDefault();
      let token = TokenService.getToken();
      if (token) {
        let payload = {
          MovieID: movieID,
          Like: 1,
          FireBaseID: "",
          favourite: !movieDetails.favourite
        };
        makeRequest("/AddFavourite", "POST", token, payload)
          .then(response => {
            const { error, res } = response;
            if (res.data) {
              this.visibleShows.show = this.visibleShows.show.map(movie => {
                if (movie.id == movieID) {
                  movie.favourite = !movie.favourite;
                }
                return movie;
              });
            }
          })
          .catch(error => {});
      } else {
        EventBus.$emit("openSignInModal");
      }
    },
    filterShow: function(filter) {
      if (filter == "nowShowing") {
        this.visibleShows = {
          show: [...this.Shows[0].show, ...this.Shows[1].show]
        };
        this.visibleShows.show = uniqBy(this.visibleShows.show, "title");
        this.visibleShows.cat_id = this.Shows[0].cat_id;
      } else if (filter == "Alternate") {
        this.visibleShows = this.Shows[1];
        this.visibleShows.cat_id = this.Shows[1].cat_id;
      } else if (filter == "Coming Soon") {
        this.visibleShows = this.Shows[2];
        this.visibleShows.cat_id = this.Shows[2].cat_id;
      }
    },
    getNowShowingData: function() {
      this.showLoading();
      this.visibleShows.show = [];
      let _title = this.visibleShows.title;
      this.Shows = [];
      let payload = {
        BannerType: "Home"
      };
      // if (this.dropDowns.locations.selected.Title != "All Locations") {
      //   payload.LocationID = this.dropDowns.locations.selected.LocationID;
      // }
      // if (this.dropDowns.languages.selected.LanguageName != "All Languages") {
      //   payload.MovieLanguageID = this.dropDowns.languages.selected.LanguageID;
      // }
      // if (this.dropDowns.genre.selected.Genre != "All Genre") {
      //   payload.Genre = this.dropDowns.genre.selected.GenreID;
      // }
      // if (this.dropDowns.experience.selected.Format != "All Experience") {
      //   payload.Format = this.dropDowns.experience.selected.FormatID;
      // }
      // payload[]

      Object.keys(this.selectedFilter).map(x => {
        if (this.selectedFilter[x].length > 0) {
          payload[x] = this.selectedFilter[x].toString();
        }
      });

      makeRequest("/GetAllShow", "POST", null, payload)
        .then(response => {
          this.hideLoading();

          const { error, res } = response;
          // console.log("movie", error, res);
          let obj = {
            movie: true,
            movie_card_img: "@/assets/img/aquaman_1475_555.jpg"
          };
          this.Shows = res.data.Shows;

          if (res.data.displayPromotionPopup != "" && this.showOfferPopup) {
            EventBus.$emit("fetchuser");
            setTimeout(() => {
              this.popupImg = res.data.displayPromotionPopup;
              this.onShowCurrentModal("offerpopup");
              this.showOfferPopup = false;
            }, 2000);
          }

          this.Banners = res.data.Banners;
          if (this.project == "ticketak") {
            this.Banners = this.Banners.filter(singleBanner => {
              if (singleBanner.banner.BannerType == "Home") {
                return singleBanner;
              }
            });
          }
          // this.Banners.push(obj);
          // this.$refs.slick1.destroy();
          // this.$nextTick(() => {
          //   this.$refs.slick1.create();
          //   this.$refs.slick1.goTo(1, true);
          // });
          this.Shows.map(shows => {
            shows.show.map(x => {
              x.url = "/movie/" + x.id + "/0";
            });
          });
          if (this.visibleShows.title == "Now Showing") {
            this.visibleShows = {
              show: [...this.Shows[0].show, ...this.Shows[1].show]
            };
            this.visibleShows.show = uniqBy(this.visibleShows.show, "title");
            // console.log(newObj)
            this.visibleShows.cat_id = this.Shows[0].cat_id;
          } else if (this.visibleShows.title == "Alternate") {
            this.visibleShows = this.Shows[1];
            this.visibleShows.cat_id = this.Shows[1].cat_id;
          } else if (this.visibleShows.title == "Coming Soon") {
            this.visibleShows = this.Shows[2];
            this.visibleShows.cat_id = this.Shows[2].cat_id;
          }

          if (_title == "Now Showing") {
            this.visibleShows.title = "Now Showing";
          } else if (_title == "Alternate") {
            this.visibleShows.title = "Alternate";
          } else if (_title == "Coming Soon") {
            this.visibleShows.title = "Coming Soon";
          }
          // this.newReleases = res.data.Shows[0].show;
          // this.newReleases.map(x => {
          //   x.url = "/movie/" + x.id;
          // });
        })
        .catch(error => {
          this.hideLoading();
          console.log("Error", error);
        });
    },
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },

    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      console.log("handleAfterChange", event, slick, currentSlide);
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      console.log("handleBeforeChange", event, slick, currentSlide, nextSlide);
    },
    handleBreakpoint(event, slick, breakpoint) {
      console.log("handleBreakpoint", event, slick, breakpoint);
    },
    handleDestroy(event, slick) {
      console.log("handleDestroy", event, slick);
    },
    handleEdge(event, slick, direction) {
      console.log("handleEdge", event, slick, direction);
    },
    handleInit(event, slick) {
      console.log("handleInit", event, slick);
    },
    handleReInit(event, slick) {
      console.log("handleReInit", event, slick);
    },
    handleSetPosition(event, slick) {
      console.log("handleSetPosition", event, slick);
    },
    handleSwipe(event, slick, direction) {
      console.log("handleSwipe", event, slick, direction);
    },
    handleLazyLoaded(event, slick, image, imageSource) {
      console.log("handleLazyLoaded", event, slick, image, imageSource);
    },
    handleLazeLoadError(event, slick, image, imageSource) {
      console.log("handleLazeLoadError", event, slick, image, imageSource);
    }
  }
};
</script>
<style>
.border {
  border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home.vue